import { gql } from '@apollo/client';

export const slideContent = `
            widgetConfigId
            granularity{
                unit
                value
            }
            contentTypeList
            excludeKeywords
            retweetFilter
            talkType
            ageGeneration
            fromUsername
            includeKeywords
            metric
            category
            objectGroupId
            objectList
            postOwnership
            retweetFromOriginalIds
            sentiment
            sentimentConfidenceLevelMax
            sentimentConfidenceLevelMin
            showEmptyLabel
            timezone
            titleContent
            validationList
            visualization
            sourceType
            dataSource
            comparisonId
            quantity
            page
            limitRow
            sortingByColumn
            labelList
            replyToOriginalId
          comparisonIdOnlineMedia
          comparisonIdOfflineMedia
          mediaList
          searchType
          clippingId
          languageList
          additionalType
          lookbackPeriods
          periodGranularity {
            value
            unit
          }
          periodOverPeriodEnabled
          piechartVisualizationConfig
          summaryType
          dailyTopicLimit
          advancedMetricAddon
          limitGroup
          limitData
          topTalkerInfluencerAddon
          additionalLabelIds
          excludeMediaList
          mediaGroup {
            tier
            includeMediaList
            excludeMediaList
          }
          tier
          includePhraseBooleanOperator
          excludePhraseBooleanOperator
          countryCode
          excludeLabelIds
            `;
// customReportId
// projectId
// slideId

export const slideLayoutDetails = `
          sectionHeader {
            title
          }
          titleSlide {
            title
            subTitle
          }
          singleContents {
            title
            contents {
              ${slideContent}
            }
          }
          twoContents {
            title
            contents {
              ${slideContent}
            }
          }
          threeContents {
            title
            contents {
              ${slideContent}
            }
          }
          fourContents {
            title
            contents {
              ${slideContent}
            }
          }
          nineContents {
            title
            contents {
              ${slideContent}
            }
          }
          oneTwoContents {
            title
            contents {
              ${slideContent}
            }
          }
          oneThreeContents {
            title
            contents {
              ${slideContent}
            }
          }
          twoOneContents {
            title
            contents {
              ${slideContent}
            }
          }
          threeOneContents {
            title
            contents {
              ${slideContent}
            }
          }
          verticalFourContents {
            title
            contents {
              ${slideContent}
            }
          }
          sixContents {
            title
            contents {
              ${slideContent}
            }
          }
          leftOneFourContents {
            title
            contents {
              ${slideContent}
            }
          }
          leftOneTwoContents {
            title
            contents {
              ${slideContent}
            }
          }
          fourTopAndLeftTwoTwoContents {
            title
            contents {
              ${slideContent}
            }
          }
          oneOneContents {
            title
            contents {
              ${slideContent}
            }
          }
          oneLeftOneCenterTwoLeft {
            title
            contents {
              ${slideContent}
            }
          }
          fourTopTwoBottom {
            title
            contents {
              ${slideContent}
            }
          }
          fourTopThreeBottom {
            title
            contents {
              ${slideContent}
            }
          }
          threeTopTwoBottom {
            title
            contents {
              ${slideContent}
            }
          }
          fourTopOneBottom {
            title
            contents {
              ${slideContent}
            }
          }
          threeColumnContents {
            title
            contents {
              ${slideContent}
            }
          }
          threeRowsContents {
            title
            contents {
              ${slideContent}
            }
          }
          verticalFiveContents {
            title
            contents {
              ${slideContent}
            }
          }
      `;

export const GET_REPORT_LIST = gql`
  query customReportV2_getCustomReport(
    $projectId: Id!
    $page: Int!
    $limit: Int!
    $name: String
  ) {
    customReportV2_getCustomReport(
      projectId: $projectId
      page: $page
      limit: $limit
      name: $name
    ) {
      limit
      page
      totalRows
      totalPages
      result {
        id
        displayName
        createdAt
        logo
        start
        end
        sentimentColor {
          positive
          negative
          neutral
        }
        schedule {
          scheduledSlideReportId
          customReportId
          deliveryFrequency
          recipientEmail
          timezone
          deliveryTime
          dayOfWeek
          dateOfMonth
          isActive
        }
      }
    }
  }
`;

export const GET_REPORT_BY_ID = gql`
  query customReportV2_getCustomReportById($customReportId: Id!) {
    customReportV2_getCustomReportById(customReportId: $customReportId) {
      id
      name
      displayName
      start
      end
      logo
      createdAt
      sentimentColor {
        positive
        negative
        neutral
      }
    }
  }
`;

export const GET_SLIDES = gql`
  query customReportV2_getSlidesWithPagination(
    $projectId: Id!
    $customReportId: Id!
    $page: Int!
    $limit: Int!
  ) {
    customReportV2_getSlidesWithPagination(
      projectId: $projectId
      customReportId: $customReportId
      page: $page
      limit: $limit
    ) {
      limit
      page
      totalRows
      totalPages
      result {
        id
        pagePosition
        slideType
        summary
        summaryPosition
        details {
          ${slideLayoutDetails}
        }
      }
    }
  }
`;

export const GET_REPORT_METRICS_OPTION = gql`
  query customReportv2_getMetrics {
    customReportV2_getMetrics {
      category
      metrics {
        label
        value
      }
    }
  }
`;

export const GET_REPORT_VISUALIZATION = gql`
  query customReportV2_getVisualizations($metric: String!, $category: String!) {
    customReportV2_getVisualizations(metric: $metric, category: $category) {
      label
      value
    }
  }
`;

export const GET_WIDGET_DATA = gql`
  query customReportV2_getWidgetData(
    $customReportArgument: CustomReportWidgetArgument!
    $slideId: Id!
    $startDate: Timestamp!
    $endDate: Timestamp!
  ) {
    customReportV2_getWidgetData(
      customReportArgument: $customReportArgument
      slideId: $slideId
      startDate: $startDate
      endDate: $endDate
    ) {
      responseType
      metaData {
        metaDataType
        topics {
          timestamp
          value
        }
        growth {
          timestamp
          value
          growth
        }
        sentiments
      }
      details {
        chronologicalGroup {
          contentType
          values {
            timestamp
            value
          }
        }
        chronological {
          contentType
          values {
            timestamp
            value
          }
        }
        nameValue {
          name
          value
        }
        table {
          header
          body {
            cells {
              cellName
              cellValue
            }
          }
          rowCount
        }
        numericWithGrowth {
          recentValue
          growth
          pastValue
          contentType
          __typename
        }
        user {
          socialMedia
          fromName
          value
          talk
          followers
        }
        peakTime {
          peakTimeValue {
            name
            data
          }
          max
          min
        }
        groupSentiment {
          groupName
          positive
          neutral
          negative
        }
        groupTier {
          groupName
          tier1
          tier2
          tier3
        }
        groupPosition {
          name
          popularity
          positivity
        }
        streamOutput {
          originalId
          socialMedia
          displayPicture
          fromId
          fromName
          timestamp
          shareCount
          likeCount
          commentCount
          engagement
          engagementRate
          content
          link
          label {
            displayName
            id
          }
          reach
          impression
          contentType
          sentiment
          viewCount
          mediaLink
        }
        numericOutput {
          value
          name
        }
        onlineMediaStream {
          originalId
          createdAt
          datePublished
          displayPicture
          title
          content
          link
          sourceName
        }
        conversationByMedia {
          socialMedia
          talk
          talker
          reach
          impression
        }
        quotationWithPersonGroup {
          name
          value
          image
          position
          list {
            content
            link
          }
        }
        summary
        topicSocialMediaOutput {
          name
          value
          dominantValue
          percentage
          dominantSentiment
          sampleContent {
            title
            content
            link
          }
          platform {
            name
            icon
            positive
            negative
            neutral
            total
            dominantValue
            dominantSentiment
            samplePositive {
              title
              content
              link
            }
            sampleNeutral {
              title
              content
              link
            }
            sampleNegative {
              title
              content
              link
            }
          }
        }
        topicOnlineMediaOutput {
          name
          positive
          negative
          neutral
          value
          dominantValue
          dominantSentiment
          percentage
        }
        nestedNameValue {
          name
          details {
            name
            value
          }
        }
        perception {
          name
          positive
          negative
          neutral
          value
          dominantValue
          dominantSentiment
          percentage
          sampleContent {
            title
            content
            link
          }
          platform {
            name
            icon
            positive
            negative
            neutral
            total
            dominantValue
            dominantSentiment
            samplePositive {
              title
              content
              link
            }
            sampleNegative {
              title
              content
              link
            }
            sampleNeutral {
              title
              content
              link
            }
          }
        }
        tableSentimentGroup {
          header
          body {
            rowName
            cells {
              columnName
              totalData
              error
              topics {
                sentiment
                topic
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_WIZARD_TEMPLATE_LIST = gql`
  query CustomReportTemplate_getAllTemplate(
    $page: Int!
    $limit: Int!
    $name: String
  ) {
    customReportTemplate_getAllTemplate(
      page: $page
      limit: $limit
      name: $name
    ) {
      limit
      page
      totalRows
      totalPages
      result {
        id
        name
        description
        isActive
        createdAt
        sectionCount
      }
    }
  }
`;

export const GET_WIZARD_TEMPLATE_DATA_SOURCES = gql`
  query CustomReportTemplate_getTemplateDataSource($templateId: Id!) {
    customReportTemplate_getTemplateDataSource(templateId: $templateId) {
      id
      templateName
      templateDescription
      sections {
        id
        sectionName
        sectionPosition
        dataSources {
          id
          labelName
          sourceType
          dataSourceType
        }
      }
    }
  }
`;

export const GET_SCHEDULED_SLIDE_REPORT_HISTORY = gql`
  query customReportV2_getScheduleSlideReportHistory(
    $id: Id!
    $page: Int!
    $limit: Int!
  ) {
    customReportV2_getScheduleSlideReportHistory(
      id: $id
      page: $page
      limit: $limit
    ) {
      limit
      page
      totalRows
      totalPages
      result {
        id
        startDate
        endDate
        status
        fileName
        errorDetail
        link
        createdAt
      }
    }
  }
`;

export const GET_GENERATED_SLIDE_SUMMARY = gql`
  query customReportV2_getGeneratedSummary(
    $projectId: Id!
    $customReportId: Id!
    $slideId: Id!
    $startDate: Timestamp!
    $endDate: Timestamp!
  ) {
    customReportV2_getGeneratedSummary(
      projectId: $projectId
      customReportId: $customReportId
      slideId: $slideId
      startDate: $startDate
      endDate: $endDate
    ) {
      summary
      summaryPosition
    }
  }
`;
